<template>
  <div class="reservation-box">
    <div>
      <el-tag :type="classificationTagType">{{ reservation.classification }}</el-tag>{{ printTime }}
    </div>
    <div>
      {{ reservation.name }}
    </div>
    <div>
      {{ printCustomer(reservation) }} 様
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ReservationTableReservationBox',
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    classificationTagType () {
      switch (this.reservation.classification) {
        case '法定点検':
          return 'warning'
        case '修理':
          return 'danger'
        default:
          return ''
      }
    },
    printTime () {
      let start = moment(this.reservation.startAt).format('H:mm')
      let end = moment(this.reservation.endAt).format('H:mm')
      return `${start} 〜 ${end}`
    },
  },
  methods: {
    printCustomer (reservation) {
      const c = reservation.customer
      return c.familyNameKana + (c.firstNameKana ? ` ${c.firstNameKana}` : '')
    },
  },
}
</script>

<style scoped>
.reservation-box {
  z-index: 10;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #efefef;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/Box.vue